/**
 * OTABookPanel — partner booking buttons (OTA-referral model).
 * Every stay is booked on Booking.com / Agoda / Vrbo / Trip.com;
 * links are deep-linked with city + dates + guests when available.
 */
import React, { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import axios from 'axios';
import { BACKEND_URL } from '../config';

const API_BASE = `${BACKEND_URL}/api`;

const toIso = (d) => (d instanceof Date ? d.toISOString().split('T')[0] : d);

export const OTABookPanel = ({ city, checkIn, checkOut, adults = 2 }) => {
  const [partners, setPartners] = useState([]);
  const hasDates = Boolean(checkIn && checkOut);

  useEffect(() => {
    let cancelled = false;
    const req = hasDates
      ? axios.get(`${API_BASE}/hotels/deeplinks`, {
          params: { city, check_in: toIso(checkIn), check_out: toIso(checkOut), adults, subid: 'property' },
        })
      : axios.get(`${API_BASE}/hotels/partners`, { params: { subid: 'property' } });
    req.then((r) => { if (!cancelled) setPartners(r.data.partners || []); }).catch(() => {});
    return () => { cancelled = true; };
  }, [city, checkIn, checkOut, adults, hasDates]);

  if (partners.length === 0) return null;

  return (
    <div data-testid="ota-book-panel">
      <p className="text-sm font-semibold text-gray-900 mb-2">Book this stay on a partner site</p>
      <div className="grid grid-cols-2 gap-2">
        {partners.map((p) => (
          <a
            key={p.key}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="inline-flex items-center justify-center gap-1.5 text-xs font-bold text-white py-2.5 rounded-full hover:opacity-90 transition-opacity"
            style={{ background: p.color }}
            data-testid={`ota-book-${p.key}`}
          >
            {p.name} <ExternalLink className="w-3 h-3" />
          </a>
        ))}
      </div>
      <p className="text-center text-xs text-gray-500 mt-3">
        {hasDates
          ? 'Your dates and guests carry over — search this property on the partner site to complete your booking.'
          : 'Pick your dates above and the links will carry them over.'}
      </p>
    </div>
  );
};

export default OTABookPanel;
